import React from 'react';
import {withDynamicComponents} from 'higher-order-components';
import HeroImage from '../../containers/hero-image';

import PhotoInfo from '../../containers/photo-info';

const HeroImageBlock = props => <HeroImage {...props} />;
HeroImageBlock.displayName = 'HeroImage';

export default withDynamicComponents({
  componentWhitelist: [
    PhotoInfo,
  ],
  mapInputToOutput: [
    ['photoInfo', 'photoInfo'],
  ],
})(HeroImageBlock);



// WEBPACK FOOTER //
// ./src/blocks/hero-image/index.jsx